import React from "react"

import WPImage, { DISPLAY_MODE } from "../_base/WPImage"

import * as agendaBusinessWeekStyles from "../../styles/landing_pages/AgendaBusinessWeek.module.css"

const AgendaBusinessWeek = props => {
  const { content } = props

  return (
    <div id="agenda-business-week" className="container-fluid">
      <div className={`row ${agendaBusinessWeekStyles.wrapper}`}>
        <div className="col">
          <div style={{ display: "grid", gridAutoRows: "1fr" }}>
            <div
              style={{
                gridArea: "1/1",
                position: "relative",
                placeItems: "left",
                display: "grid",
                zIndex: 2,
              }}
            >
              <div className={`row g-0`}>
                <div className={`col-12 ${agendaBusinessWeekStyles.content}`}>
                  <div className={`row g-0`}>
                    <div
                      className={`col-12 ${agendaBusinessWeekStyles.wrapper}`}
                    >
                      <h1>Agenda & Timing</h1>
                    </div>
                  </div>
                  <div className={`row g-0`}>
                    <div
                      className={`col-12 ${agendaBusinessWeekStyles.tableWrapper}`}
                    >
                      <table
                        className={`table ${agendaBusinessWeekStyles.table}`}
                      >
                        <colgroup>
                          <col style={{ width: "20%", textAlign: "left" }} />
                          <col style={{ width: "20%", textAlign: "left" }} />
                          <col style={{ width: "50%", textAlign: "left" }} />
                          <col style={{ width: "10%", textAlign: "center" }} />
                        </colgroup>
                        <thead>
                          <tr>
                            <th scope="col">Date</th>
                            <th scope="col">Webinar</th>
                            <th scope="col">Description</th>
                            <th scope="col">Register</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr className={`${agendaBusinessWeekStyles.colored}`}>
                            <th scope="row" data-label="Date">
                              <span data-label="Date">
                                Aug 26 Tuesday
                                <br /> 11:00 am EST
                              </span>
                            </th>
                            <td data-label="Webinar">
                              Supply Chain - Tackling the Beast & Accelerating
                              Organizational Outcomes
                            </td>
                            <td data-label="Description">
                              The world runs on goods being transported from all
                              corners of the world. If your organization doesn't
                              have the right product at the right place at the
                              right time, it is very likely that your vendors,
                              end-customers, and your management will let you
                              know their frustrations on how the delays affected
                              their events or business.
                              <br />
                              <br /> #DoGoodTM1.{" "}
                            </td>
                            <td data-label="Register">
                              <a href="https://events.teams.microsoft.com/event/06233dcb-aed6-40d1-ad28-c0df3334b3c6@0635d657-0279-4110-9c8f-2ee27b1e065b">
                                Register
                              </a>
                            </td>
                          </tr>
                          <tr>
                            <th scope="row" data-label="Date">
                              <span data-label="Date">
                                Aug 27 Wednesday
                                <br /> 11:00 am EST
                              </span>
                            </th>

                            <td data-label="Webinar">
                              Financial Consolidation – Let’s Shorten & Simplify
                              the Process​
                            </td>
                            <td data-label="Description">
                              A fast, reliable close does more than save time.
                              It ensures compliance, strengthens stakeholder
                              trust, and frees your finance team to focus on
                              strategic growth.​
                              <br />
                              <br />​ Join our webinar to see how the right
                              technology can dramatically shorten your close
                              cycle, eliminate manual reconciliations, and
                              improve audit readiness to transform your
                              month-end close from a stressful marathon into a
                              streamlined, confident process.
                              <br />
                              <br /> #DoGoodTM1
                            </td>
                            <td data-label="Register">
                              <a href="https://events.teams.microsoft.com/event/5c4689d2-7733-4ebc-9c06-3d1aaf82a0bc@0635d657-0279-4110-9c8f-2ee27b1e065b">
                                Register
                              </a>
                            </td>
                          </tr>
                          <tr className={`${agendaBusinessWeekStyles.colored}`}>
                            <th scope="row">
                              <span data-label="Date">
                                Aug 28 Thursday <br /> 11:00 am EST
                              </span>
                            </th>
                            <td data-label="Webinar">
                              Mastering Financial Forecasting in Real Time
                            </td>
                            <td data-label="Description">
                              In today's fast paced business environment,
                              accurate forecasting isn't an advantage, it is a
                              necessity!​​
                              <br />
                              <br />
                              Join us for an insightful session where we unpack
                              strategies, tools, and methodologies to drive real
                              world results to increase forecast accuracy.
                              <br />
                              <br /> #DoGoodTM1
                            </td>
                            <td data-label="Register">
                              <a href="https://events.teams.microsoft.com/event/6be3363a-35cc-444b-b668-5eeed7924039@0635d657-0279-4110-9c8f-2ee27b1e065b">
                                Register
                              </a>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className={`${agendaBusinessWeekStyles.backgroundContainmentImage}`}
              style={{
                gridArea: "1/1",
                objectFit: "cover",
                placeItems: "right",
                zIndex: 1,
              }}
              objectfit="cover"
              placeholderstyle={{
                objectFit: `cover`,
                objectPosition: `right bottom`,
              }}
              imgstyle={{
                objectFit: `cover`,
                objectPosition: `right bottom`,
              }}
              transformoptions={{ fit: "cover" }}
            >
              <WPImage
                holder={content}
                selector={`media-asset`}
                mode={DISPLAY_MODE.normal}
                className={`d-none d-lg-flex ${agendaBusinessWeekStyles.backgroundImage}`}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AgendaBusinessWeek
